export default __webpack_public_path__ + "media/images/front/user_page_announcement/point_pc-1e50d26c4d9a9b88034995adfe531f66.png";